import React, { useEffect, useState } from "react";
import { ITransport } from "dataModels/contract";
import { Select, Input as TextInput} from "@ds/ds-snam/react";
import { /*Container,*/ Row, Col } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { dsDeselectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { myCountryArraySelect, myCountryArraySelectEN, provinceMap, states } from "shared/domains/formDomains";

interface ITransportFormDataInputProps {
    formData: ITransport,
    phoneError: boolean,
    onTextInputChange: (inputEvent: Event) => void,
    onStateInputChange: (inputEvent: Event) => void,
    onSelectInputChange: (inputEvent: Event,fieldName:string) => void
    //onDateInputChange: (inputEvent: Event, fieldName: string) => void
}

const TransportFormDataInput: React.FC<ITransportFormDataInputProps> = (props): JSX.Element => {
    const {t} = useTranslation(['contract']);
    const { i18n } = useTranslation();
    const { formData, phoneError, onTextInputChange, onStateInputChange,onSelectInputChange} = props;
    const [provinceOptions, setProvinceOptions] = useState<ISelectLabel[]>([]);
    const [stateOptions,setStateOptions] = useState<ISelectLabel[]>([]);
    const [statesOptions,setStatesOptions] = useState<ISelectLabel[]>([]);


    const updateStateProvince = () => {
        if(formData.businessState===''){
            let states:ISelectLabel[] =i18n.language==='it'?myCountryArraySelect:myCountryArraySelectEN
            dsDeselectHandler(states)
            setStateOptions(states);
        }else{
            let selectedByLan = i18n.language==='it'?myCountryArraySelect:myCountryArraySelectEN
            setStateOptions(selectedByLan);
            const updatedProvinces = provinceMap[formData.businessState] || provinceMap["default"];
            setProvinceOptions(updatedProvinces);
            // Seleziona lo stato
            const selectedState = selectedByLan.find((state) => state.id === formData.businessState);
            if (selectedState) {
                dsSelectHandler(selectedByLan, selectedState); // Seleziona lo stato
            }

            // Seleziona la provincia
            const selectedProvince = updatedProvinces.find((province) => province.id === formData.businessProvince);
            if (selectedProvince) {
                dsSelectHandler(updatedProvinces, selectedProvince); // Seleziona la provincia
            }
        }
    }
    useEffect(()=>{
        updateStateProvince();
        if(formData.countryCode===''){
            let myStates:ISelectLabel[] = states
            dsDeselectHandler(myStates)
            setStatesOptions(myStates);
        }else{
            setStatesOptions(states);
            const selectedCountryCode = states.find((state) => state.id === formData.countryCode);
            if (selectedCountryCode) {
                dsSelectHandler(states, selectedCountryCode); // Seleziona il country code
            }
        }
    },[])

    useEffect(()=>{
        updateStateProvince()
    },[i18n.language])


    return (
        <>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.0')+"*"}//"Nome Azienda*"
                                inputValue={formData.businessName}
                                inputName="businessName"
                                inputId="businessName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.0')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.1')+"*"}//"Partita IVA / Cod. fiscale*"
                                inputValue={formData.vat}
                                inputName="vat"
                                inputId="vat"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.1')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.2')+"*"}//"Ragione sociale*"
                                inputValue={formData.businessSecondName}
                                inputName="businessSecondName"
                                inputId="businessSecondName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.2')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.3')+"*"}//"Indirizzo aziendale*"
                                inputValue={formData.businessAddress}
                                inputName="businessAddress"
                                inputId="businessAddress"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.3')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.4')+"*"}//"Civico*"
                                inputValue={formData.businessStreetNumber}
                                inputName="businessStreetNumber"
                                inputId="businessStreetNumber"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.4')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={true} //SRINGTOONLYNUMBER
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                minValue={0}
                                maxDecimalDigits={0}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.5')+"*"}//"Città*"
                                inputValue={formData.businessCity}
                                inputName="businessCity"
                                inputId="businessCity"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.5')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                
                
            </Row>
            <Row>
            <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.info.fields.6')+"*"}//"CAP*"
                                inputValue={formData.businessPostalCode}
                                inputName="businessPostalCode"
                                inputId="businessPostalCode"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.info.fields.6')+"*"}
                                isDisabled={false}
                                minValue={0}
                                maxDecimalDigits={0}
                                input-event-type="single_character"
                                isNumberVariant={true} //STRINGTOONLYNUMBER
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                            <Select
                                id={'id-select-nation'}
                                menuPlaceholder={t('transporter.transporterForm.sections.info.fields.8')+"*"}//"Stato*"
                                hasIcon={false}
                                menuOptions={stateOptions}
                                menuLabel={t('transporter.transporterForm.sections.info.fields.8')+"*"}//"Stato*"
                                menuId="select-id"
                                isDisabled={false}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(stateOptions!, selection);         
                                    //aggiorna province
                                    const updatedProvinces = provinceMap[selection.value!] || provinceMap["default"];
                                    dsDeselectHandler(updatedProvinces)
                                    setProvinceOptions(updatedProvinces);        
                                    // Pulisci il valore della provincia (stringa vuota)
                                    if (JSON.stringify(updatedProvinces) !== JSON.stringify(provinceOptions)) {
                                        onSelectInputChange({ detail: { option: { value: '' } } } as unknown as CustomEvent, "businessProvince");
                                    }                             
                                    onSelectInputChange(event,"businessState")
                                }}
                            ></Select>
                    </div>
                </Col>
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                            <Select
                                id="id-select-province"
                                menuPlaceholder={t('transporter.transporterForm.sections.info.fields.7')+"*"}//"Provincia*"
                                menuOptions={provinceOptions} // Opzioni province dinamiche
                                menuLabel={t('transporter.transporterForm.sections.info.fields.7')+"*"}//"Provincia*"
                                isDisabled={provinceOptions.length === 0} // Disabilita il menu se non ci sono province
                                onOptionSelection={(event: Event) => {
                                    const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(provinceOptions!, selection);
                                    onSelectInputChange(event, "businessProvince")
                                }}
                            />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="new-contract-form--subtitle">
                        {/*Persona di contatto*/}
                        {t('transporter.transporterForm.sections.contactPerson.title')}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.contactPerson.fields.0')+"*"}//"Nome*"
                                inputValue={formData.firstName}
                                inputName="firstName"
                                inputId="firstName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.contactPerson.fields.0')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.contactPerson.fields.1')+"*"}//"Cognome*"
                                inputValue={formData.secondName}
                                inputName="secondName"
                                inputId="secondName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.contactPerson.fields.1')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                            {/*
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.contactPerson.fields.2')+"*"}//"Stato*"
                                inputValue={formData.countryCode}
                                inputName="countryCode"
                                inputId="countryCode"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                            */}
                            <Select
                                id={'id-select-stateField_1'}
                                menuPlaceholder={t('transporter.transporterForm.sections.contactPerson.fields.2')+"*"}
                                hasIcon={false}
                                menuOptions={statesOptions === undefined ? [] : statesOptions} 
                                menuLabel={t('transporter.transporterForm.sections.contactPerson.fields.2')+"*"}
                                menuId="select-id"
                                isDisabled={statesOptions === undefined}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    //console.log((event as CustomEvent).detail.option.value);
                                    onStateInputChange(event)
                                    const selectedOption = (event as CustomEvent).detail.option;
                                    dsSelectHandler(statesOptions as ISelectLabel[], selectedOption);
                                }}
                            ></Select>
                    </div>
                </Col>
                <Col xs={12} md={2}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.contactPerson.fields.3')+"*"}//"Numero di cellulare*"
                                inputValue={formData.phone}
                                inputName="phone"
                                inputId="phone"
                                inputDescription={phoneError ? t('transporter.transporterForm.sections.contactPerson.errorPhone') : ""}
                                inputStatus={phoneError ? "error" : "default"}
                                inputPlaceholder={t('transporter.transporterForm.sections.contactPerson.fields.3')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
                <Col xs={12} md={4}>
                    <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('transporter.transporterForm.sections.contactPerson.fields.4')+"*"}//"Email personale*"
                                inputValue={formData.email}
                                inputName="email"
                                inputId="email"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('transporter.transporterForm.sections.contactPerson.fields.4')+"*"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                incrementButtonAriaLabel="increment aria text"
                                decrementButtonAriaLabel="decrement aria text"
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                    </div>
                </Col>
            </Row>
        </>
    );
}
export default TransportFormDataInput;